export default __webpack_public_path__ + "assets/audios/e007ef9b39912a6378b18990d7821c2e.mp3";